/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  LetterbooksPublisherConditionType,
} from "features/Letterbooks/types";
import { LetterbooksParentPublisherContextType } from "types/LetterbooksParentContextType";

export default function libraryConditions(
  context: LetterbooksParentPublisherContextType
): LetterbooksPublisherConditionType {
  const { publisher } = context;

  return {
    publisher_id: publisher.id,
  };
}
